import React from 'react'
import { Link } from 'react-router-dom'

const ListEmpty = () => {
  return (
    <div className='cart-side col-12 col-md-8 px-0 pr-md-2 mb-2 mb-md-0'>
      <div className='border-ui-3 radius bg-white'>
        <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
          <h3 className='color-title txt-font-body'>Carrinho de compras</h3>
        </div>
        <div className='cart-products col-12 py-3 mx-0'>
          <div className='row'>
            <div className='mr-auto ml-auto bg-ui-4 radius-circle px-3 py-3'>
              <i className='icon icon_cart txt-headline color-brand-1' />
            </div>
            <div className='col-12 clearfix' />
            <div className='mr-auto ml-auto col-7 mt-2'>
              <h3 className='txt-center txt-body'>
                <strong>Seu carrinho está vazio.</strong>
              </h3>
              <p className='txt-center txt-body-sm'>
                Você ainda não adicionou nenhum produto no carrinho.
              </p>
              <p className='txt-center txt-body-sm'>
                Aproveite agora nossas ofertas!
              </p>
            </div>
            <div className='col-12 clearfix' />
            <div className='mr-auto ml-auto txt-center col-8 col-md-4 py-2'>
              <Link
                to='/search'
                className='btn btn-sm btn-featured txt-button txt-font-body'
              >
                Ver Produtos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListEmpty



// WEBPACK FOOTER //
// ./src/features/Cart/List/ListEmpty.js